import { MyDrawer } from 'components/MyDrawer'
import { Trans, useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { useEffect } from 'react'
import { setActiveTrap } from 'redux/reducers/modal'

import checkImg from './check.png'

type EasyPayHelpDrawerProps = {
  onClose: () => void
}
export function EasyPayHelpDrawer ({ onClose }: EasyPayHelpDrawerProps) {
  const { t } = useTranslation('easyPayCommon')

  // TODO - remove this once we can switch over to native <dialog>
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(setActiveTrap({ isActiveTrap: true }))

    return () => {
      dispatch(setActiveTrap({ isActiveTrap: false }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <MyDrawer
      heading={t('helpDrawer.heading')}
      onClose={onClose}
      containerId="medicare-my-easyPay-help"
    >
      <p>
        <Trans t={t} i18nKey="helpDrawer.p1" />
      </p>
      <p>
        <Trans t={t} i18nKey="helpDrawer.p2" />
      </p>
      <p>
        <img src={checkImg} alt={t('helpDrawer.checkAlt')} style={{ width: '100%', height: 'auto' }} />
      </p>
      <p>{t('helpDrawer.p3')}</p>
    </MyDrawer>
  )
}

export default EasyPayHelpDrawer
